export const DAY_NAMES = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

export const DAY_THEMES = {
  Monday:    { color: "#2E6BE6", light: "#EAF0FF", label: "🌅 Monday"    },
  Tuesday:   { color: "#3377FF", light: "#E0EBFF", label: "💻 Tuesday"   },
  Wednesday: { color: "#0B0B0B", light: "#F3F4F6", label: "⚙️ Wednesday" },
  Thursday:  { color: "#2659BF", light: "#EAF0FF", label: "🔬 Thursday"  },
  Friday:    { color: "#173673", light: "#E0EBFF", label: "⭐ Friday"     },
};

export const OS_TOOLS = [];
export const SHARED_PARAMS = [
  {
    key: "problem",
    label: "Problem Statement",
    icon: "ti-target",
    color: "#7C4FE0",
    hint: "Paste a problem, or let us suggest a few. Then check it and continue.",
  },
];

// Mode A: traditional syllabus-based params
export const SUBJECT_PARAMS = [
  {
    key: "syllabus",
    label: "Subject / College Syllabus",
    icon: "ti-books",
    color: "#0EA5E9",
    hint: "Optional short paste only. Prefer editing backend/data/collegeSyllabusInput.txt for hands-on (huge PDFs not needed)",
  },
  {
    key: "questions",
    label: "Question Banks ",
    icon: "ti-help-octagon",
    color: "#1B4F72",
    hint: "Upload all question papers (IA1, IA2, IA3, AU). They'll be analyzed to set Exam Focus topics",
  },
  {
    key: "instructions",
    label: "Additional Instructions",
    icon: "ti-adjustments",
    color: "#0E9F6E",
    hint: "Any special requirements or customisations",
  },
];

// Mode B: DSA + System Design params (replaces syllabus)
export const DSA_SD_PARAMS = [
  {
    key: "dsaSyllabus",
    label: "DSA Syllabus",
    icon: "ti-binary-tree",
    color: "#0EA5E9",
    hint: "Optional — upload/paste DSA topics. If empty, AI RAG builds a problem-specific DSA path from the web + your problem statement",
  },
  {
    key: "systemDesign",
    label: "System Design Syllabus",
    icon: "ti-topology-star",
    color: "#1B4F72",
    hint: "Optional — upload/paste System Design topics. If empty, AI RAG derives SD components for your problem from the web",
  },
  {
    key: "syllabus",
    label: "Subjects / College Syllabus",
    icon: "ti-books",
    color: "#0E9F6E",
    hint: "Optional short paste only. Prefer editing backend/data/collegeSyllabusInput.txt for hands-on (huge PDFs not needed)",
  },
  {
    key: "questions",
    label: "Question Banks",
    icon: "ti-help-octagon",
    color: "#E11D2E",
    hint: "Upload IA/AU papers — used for detailed Exam Focus in the weekly plan",
  },
  {
    key: "assessment",
    label: "Assessment & Goals",
    icon: "ti-chart-bar",
    color: "#0E9F6E",
    hint: "Company specs, IAE/global certification targets, expected package (e.g. 5–10 LPA). Used to calibrate difficulty and milestones",
  },
];

// Student profile params — distinct persona fields (solo Assessment page)
export const STUDENT_PARAMS = [
  {
    key: "capability",
    label: "Strengths (capability)",
    icon: "ti-user-check",
    color: "#7C4FE0",
    hint: "What you are good at — soft skills, tech, work style. Difficulties are a separate field.",
  },
  {
    key: "interest",
    label: "Likes & activities",
    icon: "ti-heart",
    color: "#1B4F72",
    hint: "Sports, dance, music, hobbies + light career interests — used in Mini Build.",
  },
  {
    key: "domain",
    label: "Domain / direction",
    icon: "ti-world",
    color: "#0E9F6E",
    hint: "Industry, tech focus, or role path — not hobbies.",
  },
];

export const PARAMS = [...SHARED_PARAMS, ...SUBJECT_PARAMS];

export const MODULES = [
  { key: "daily", label: "Daily Schedule", icon: "ti-calendar-week" },
  { key: "weekly", label: "Weekly Plan", icon: "ti-layout-list" },
  { key: "homework", label: "Tonight's Homework", icon: "ti-moon-stars" },
];

export const DT_STAGES = [
  {
    key: "empathize",
    label: "Empathize",
    icon: "ti-heart",
    color: "#E11D2E",
    soft: "#FDE8EA",
    desc: "Understand the problem — desk research, audience, empathy map. No coding solutions yet.",
  },
  {
    key: "define",
    label: "Define",
    icon: "ti-pencil",
    color: "#0D9488",
    soft: "#E6F7F5",
    desc: "Focus the problem — POV / focus statement, process map, peer pitch of the problem.",
  },
  {
    key: "ideate",
    label: "Plan",
    icon: "ti-map",
    color: "#1B4F72",
    soft: "#E7F0F6",
    desc: "Plan the product — user actions, app state, features, inclusion, UI/UX (SNS Plan stage).",
  },
  {
    key: "prototype",
    label: "Prototype",
    icon: "ti-tools",
    color: "#4338CA",
    soft: "#EEF2FF",
    desc: "Make it tangible — sketches, storyboard, Figma/wireframes, then light build.",
  },
  {
    key: "test",
    label: "Evaluate",
    icon: "ti-flask",
    color: "#0F9F6E",
    soft: "#E6F8F1",
    desc: "Validate with users — pitch, usability plan, observation, interview, reiterate.",
  },
  {
    key: "implement",
    label: "Pitch & BMC",
    icon: "ti-presentation",
    color: "#2E6BE6",
    soft: "#EAF0FF",
    desc: "Business wrap-up — BMC canvas, sales pitch, deck (not deploy/code).",
  },
];

export const MAX_IA = 3;
